import { all } from 'redux-saga/effects'
import auth from './auth/sagas'
import apiCall from './apiCall/sagas'
import modal from './modal/sagas'
import themeSaga from './theme/sagas'

export default function* rootSaga() {
  yield all([
    themeSaga(),
    ...auth,
    ...apiCall,
    ...modal
  ])
}
